import './Main.css';
import { useState, useEffect } from 'react';
import Demo from './Demo/Demo';
import Work from './Work/Work';
import About from './About/About';
import Contact from './Contact/Contact';

const order = ["demo", "work", "about", "contact"];

function Main({ mode, currentDog }) {
  const [displayedMode, setDisplayedMode] = useState(mode);
  const [animClass, setAnimClass] = useState("");
  
  useEffect(() => {
    if (mode === displayedMode) return;

    const oldIndex = order.indexOf(displayedMode);
    const newIndex = order.indexOf(mode);
    const direction = newIndex > oldIndex ? "left" : "right";
    
    setAnimClass(`slide-out-${direction}`);

    const timeout = setTimeout(() => {
      setDisplayedMode(mode);
      setAnimClass(`slide-in-${direction}`);
    }, 300);

    return () => clearTimeout(timeout);
  }, [mode]);

  const components = {
    demo: <Demo />,
    work: <Work />,
    about: <About />,
    contact: <Contact currentDog={currentDog} />
  };

  return (
    <main className="Main">
      <div className={`slide-wrapper ${animClass}`}>
        {components[displayedMode]}
      </div>
    </main>
  );
}

export default Main;
